import { AirportDetails } from "../../global";

export const getCityNameByAirport = (airportCode: string, airportsDataArray: AirportDetails[]) => {
  const airportDetailsData = airportsDataArray?.find(({ stationCode }) => stationCode === `${airportCode}`);

  return airportDetailsData?.cityInfo?.name || "";
};
